import React, { useEffect, useRef, useState } from 'react'

import { Box, Typography } from '@material-ui/core'
import { useStyles } from './StudentRegister_style'

import Button from 'shared/components/Button/Button'
import CloudinaryHelper from '../../../../../assets/CloudinaryHelper'
import axios from 'axios'
import Bugsnag from '@bugsnag/js'
import DocumentAPI from '../../../../../api/DocumentAPI'
import IconFactory from '../../../../shared/icons/IconFactory/IconFactory'
import RouteMap from '../../../../../assets/RouteMap'
import { FormattedMessage } from 'react-intl'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import CircularProgress from '@material-ui/core/CircularProgress'
import AnalyticsHelper from 'assets/AnalyticsHelper'

const ResumeParser = (props) => {
    const {
        handleManualCreation,
        sendEventFromOrigin
    } = props
    const RESUME_UPLOAD = 'Resume Upload'; const PROFILE_CREATION = 'Profile Creation'; const PROFILE_COMPLETED = 'Profile Completed'; const ERROR = 'Error'
    const data = useRef(null)
    const documentUrl = useRef(null)
    const funnelSteps = [RESUME_UPLOAD, PROFILE_CREATION, PROFILE_COMPLETED, ERROR]
    const [currentStep, setCurrentStep] = useState(RESUME_UPLOAD)
    const [errorMessage, setErrorMessage] = useState('landing_login_page.sign_up.ai.error4')
    const [phraseIndex, setPhraseIndex] = useState(1)
    const classes = useStyles()

    const handleFinalClick = () => {
        window.location.href = RouteMap.Page('users/profile/edit?parser_result=/&modal_open=/')
    }

    const handleError = () => {
        setCurrentStep(RESUME_UPLOAD)
    }

    useEffect(() => {
        const phrasesTimer = setInterval(() => {
            setPhraseIndex((prev) => (prev >= 4 ? 1 : prev + 1))
        }, 4000)
        return () => {
            clearInterval(phrasesTimer)
        }
    }, [])

    const postResume = (result) => {
        setCurrentStep(PROFILE_CREATION)
        data.current = {
            cloudinary_key: result.public_id,
            format: result.format,
            name: result.original_filename,
            is_pdf: true,
            is_cv: true
        }
        DocumentAPI.postDocument(data.current).then((response) => {
            documentUrl.current = response.data.document_object.asset_url
            updateProfileWithResumeParser(documentUrl.current, data.current)
        }).catch((error) => {
            alert(`An error has occurred: ${error}`)
            Bugsnag.notify(error)
        })
    }

    const uploadResume = () => {
        const cloudinaryWidget = CloudinaryHelper.createDocumentUploadWidget(
            { clientAllowedFormats: ['pdf'] },
            (error, result) => {
                if (!error && result?.event === 'success') {
                    postResume(result.info)
                }
            }
        )
        cloudinaryWidget.open({
            container: document.getElementById('uploadField')
        })
    }

    const updateProfileWithResumeParser = (documentUrl, restData) => {
        const data = { document_url: documentUrl, name: restData.name, format: restData.format, cloudinary_key: restData.cloudinary_key, is_pdf: restData.is_pdf, is_cv: restData.is_cv }
        axios({
            method: 'post',
            url: '/api/v1/register/update_profile_with_resume_parser',
            data: data
        }).then(response => {
            setCurrentStep(PROFILE_COMPLETED)
            sendEventFromOrigin()
            AnalyticsHelper.sendAnalyticsEvent('identify', { user_id: response.data.user.id })
            AnalyticsHelper.sendAnalyticsEvent('track', {
                user_id: response.data.user.id,
                event_name: 'Signup Completed',
                custom_props: { origin: props.origin }
            })
        }).catch(error => {
            setCurrentStep(ERROR)
            setErrorMessage(error.response.data)
            Bugsnag.notify(error)
        })
    }

    const renderView = () => {
        switch (currentStep) {
        case RESUME_UPLOAD:
            return (
                <form className={classes.form}>
                    <Typography className={classes.formTitleResumeParser}>
                        <FormattedMessage id='landing_login_page.sign_up.ai.quick_complete.title'/>
                    </Typography>
                    <Typography className={classes.formSubtitle}>
                        <FormattedMessage id='landing_login_page.sign_up.ai.quick_complete.description'/>
                    </Typography>
                    <Box className={classes.uploadField} id='uploadField'>
                        <Button className={classes.uploadButton} onClick={uploadResume}>
                            <FormattedMessage id='landing_login_page.sign_up.ai.browse'/>
                            <IconFactory icon="to-top" className={classes.uploadIcon} />
                        </Button>
                        <Tooltip
                            title={
                                <FormattedMessage id='landing_login_page.sign_up.ai.tooltip'>
                                    {text => <Typography dangerouslySetInnerHTML={{ __html: text }}/>}
                                </FormattedMessage>
                            }
                            placement="right"
                            classes={{ tooltip: classes.uploadHelp }}
                        >
                            <IconButton>
                                <IconFactory icon="question-circle" className={classes.infoIcon} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <Typography><FormattedMessage id='landing_login_page.sign_up.ai.or'/></Typography>
                    <Button className={classes.manualComplete} onClick={handleManualCreation}><FormattedMessage id='landing_login_page.sign_up.ai.manual_profile_creation'/></Button>
                </form>
            )
        case PROFILE_CREATION:
            return (
                <form className={classes.form}>
                    <Typography className={classes.formTitleResumeParser}>
                        <FormattedMessage id='landing_login_page.sign_up.ai.quick_complete.title'/>
                    </Typography>
                    <Typography className={classes.formSubtitle}>
                        <FormattedMessage id='landing_login_page.sign_up.ai.quick_complete.description'/>
                    </Typography>
                    <Box className={classes.barField}>
                        <Typography className={classes.completingProfile}>
                            <FormattedMessage id={`landing_login_page.sign_up.ai.completing${phraseIndex}`}/>
                        </Typography>
                        <CircularProgress color='primary' size={100}/>
                    </Box>
                    <Button className={classes.submitButton} disabled><FormattedMessage id='landing_login_page.confirm'/></Button>
                </form>
            )
        case PROFILE_COMPLETED:
            return (
                <form className={classes.form}>
                    <Typography className={classes.formTitleResumeParser}>
                        <FormattedMessage id='landing_login_page.sign_up.ai.quick_complete.title'/>
                    </Typography>
                    <Typography className={classes.formSubtitle}>
                        <FormattedMessage id='landing_login_page.sign_up.ai.quick_complete.description'/>
                    </Typography>
                    <Box className={classes.profileCompleted}>
                        <Typography className={classes.whiteText}><FormattedMessage id='landing_login_page.sign_up.ai.completed'/></Typography>
                        <IconFactory icon='circle-check' className={classes.checkIcon} />
                    </Box>
                    <Button className={classes.submitButton} onClick={handleFinalClick}><FormattedMessage id='landing_login_page.confirm'/></Button>
                </form>
            )
        case ERROR:
            return (
                <form className={classes.form}>
                    <Box className={classes.errorTitle}>
                        <FormattedMessage id='landing_login_page.sign_up.ai.bug'/>
                    </Box>
                    <Box className={classes.errorDescription}>
                        <FormattedMessage id={errorMessage}>
                            {text => <Typography dangerouslySetInnerHTML={{ __html: text }}/>}
                        </FormattedMessage>
                    </Box>
                    <Button className={classes.submitButton} onClick={handleError}><FormattedMessage id='landing_login_page.sign_up.ai.retry'/></Button>
                </form>
            )
        }
    }
    return (
        <Box className={ funnelSteps.slice(0, 3).includes(currentStep) ? classes.resumeParserContainer : classes.manualContainer}>
            {renderView(currentStep)}
        </Box>
    )
}
export default ResumeParser
